// FILE: src/components/ThemeToggle/ThemeToggle.jsx
import React from "react";
import { applyTheme, getSystemTheme, readSavedTheme, saveTheme } from "../../theme/theme";
import styles from "./ThemeToggle.module.css";

export default function ThemeToggle() {
  const [theme, setTheme] = React.useState(() => readSavedTheme() || getSystemTheme());
  const isDark = theme === "dark";

  React.useEffect(() => {
    applyTheme(theme);
    saveTheme(theme);
  }, [theme]);

  React.useEffect(() => {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const saved = readSavedTheme();
    const onChange = () => {
      if (!saved) setTheme(getSystemTheme());
    };
    mql.addEventListener?.("change", onChange);
    return () => mql.removeEventListener?.("change", onChange);
  }, []);

  return (
    <button
      type="button"
      className={styles.switch}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <span className={`${styles.icon} ${isDark ? styles.showMoon : styles.hideMoon}`} aria-hidden="true">
        🌙
      </span>
      <span className={`${styles.icon} ${isDark ? styles.hideSun : styles.showSun}`} aria-hidden="true">
        🌞
      </span>
    </button>
  );
}
